export default "__VITE_ASSET__KjuJwXzB__"